import { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { Loader2 } from "lucide-react";
import { getStats } from "../adminApi";

const CARDS = [
  { key: "totalEnquiries", label: "Total Enquiries", icon: "MessageSquareText", color: "bg-blue-500" },
  { key: "newEnquiries", label: "New Enquiries", icon: "Bell", color: "bg-orange-500" },
  { key: "internshipApplications", label: "Internship Applications", icon: "FileText", color: "bg-indigo-500" },
  { key: "shortlisted", label: "Shortlisted Candidates", icon: "UserCheck", color: "bg-amber-500" },
  { key: "selected", label: "Selected Candidates", icon: "BadgeCheck", color: "bg-emerald-500" },
  { key: "collegeRequests", label: "College Session Requests", icon: "Building2", color: "bg-violet-500" },
  { key: "contactMessages", label: "Contact Messages", icon: "Mail", color: "bg-cyan-500" },
  { key: "payments", label: "Payments", icon: "CreditCard", color: "bg-slate-500" },
];

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} />;
};

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    getStats().then(setStats).catch(() => setErr("Could not load stats."));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="mb-1 text-2xl font-bold text-slate-900">Dashboard</h1>
      <p className="mb-8 text-sm text-slate-500">Overview of ASAI enquiries, applications and requests.</p>

      {err && <div className="mb-6 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600">{err}</div>}

      {!stats && !err ? (
        <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-orange" /></div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {CARDS.map((c) => (
            <div key={c.key} data-testid={`stat-${c.key}`} className="flex items-center gap-4 rounded-xl border border-slate-200 bg-white p-5">
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${c.color} text-white`}>
                <Icon name={c.icon} className="h-6 w-6" />
              </span>
              <div>
                <div className="text-2xl font-bold text-slate-900">{stats?.[c.key] ?? 0}</div>
                <div className="text-xs text-slate-500">{c.label}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
